import { Theme } from '@mui/material'

const classes = {
  linearProgress: (theme: Theme) => ({
    borderRadius: theme.spacing(3),
    backgroundColor: theme.palette.secondary.light,
    // Stop indicator
    '&:after': {
      content: '""',
      position: 'absolute',
      top: 0,
      right: 0,
      height: '100%',
      width: theme.spacing(0.5),
      borderRadius: theme.spacing(3),
      backgroundColor: theme.palette.primary.main,
    },
    '& .MuiLinearProgress-bar1': {
      borderRadius: theme.spacing(3),
    },
  }),
}

export default classes
